import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex justify-center items-center h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-12 min-w-min 2xl:w-2/3 3xl:w-3/5"
}

import { useProjectDurationSettings } from "@oculai/planner";
import LoadingSpinner from "@/components/UI/LoadingSpinner.vue";
import { useLoadCurrentProject } from "@/composables/project";
import { apiClient } from "@/repositories/clients";
import NonWorkingDays from "@/views/settings/project/NonWorkingDays.vue";
import WorkingHours from "@/views/settings/project/WorkingHours.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabDurations',
  setup(__props) {

const { projectDurationSettings, isProjectDurationSettingsLoading } =
  useProjectDurationSettings(apiClient);
const { project, isProjectLoading } = useLoadCurrentProject();

return (_ctx: any,_cache: any) => {
  return (_unref(isProjectDurationSettingsLoading) || _unref(isProjectLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingSpinner)
      ]))
    : (_unref(projectDurationSettings) && _unref(project))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(WorkingHours, { projectDurationSettings: _unref(projectDurationSettings) }, null, 8, ["projectDurationSettings"]),
          _createVNode(NonWorkingDays, {
            projectDurationSettings: _unref(projectDurationSettings),
            project: _unref(project)
          }, null, 8, ["projectDurationSettings", "project"])
        ]))
      : _createCommentVNode("", true)
}
}

})